import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { CtaButton } from "./CtaButton";
import { PRODUCTS } from "@/lib/site";

const JG_HEADLINE = <>Ready when your <span className="font-serif italic font-normal text-[#D96B43]">knees</span> are.</>;

export const Footer = ({ product = "joint-genesis", headline = JG_HEADLINE }) => {
  const year = new Date().getFullYear();
  return (
    <footer className="relative overflow-hidden bg-[#091D18] pt-24" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col gap-10 border-b border-[#F2EDE4]/10 pb-16 md:flex-row md:items-end md:justify-between">
          <h2 className="max-w-3xl font-display text-4xl font-extrabold leading-[0.98] tracking-tight text-[#F2EDE4] sm:text-6xl">
            {headline}
          </h2>
          {product && <CtaButton testId="footer-hoplink-button" placement="footer" product={product}>Visit {PRODUCTS[product].name}</CtaButton>}
        </div>
        <div className="grid gap-10 py-12 md:grid-cols-3">
          <div>
            <Logo testId="footer-logo" />
            <div className="mt-5 flex flex-wrap gap-x-5 gap-y-2 text-sm" data-testid="footer-picks">
              <span className="text-[#F2EDE4]/55">Our picks:</span>
              {Object.entries(PRODUCTS).map(([slug, p]) => (
                <Link key={slug} to={p.path} data-testid={`footer-pick-${slug}`} className="text-[#F2EDE4]/85 underline-offset-4 hover:text-[#F2EDE4] hover:underline">{p.name}</Link>
              ))}
            </div>
          </div>
          <p className="text-xs leading-relaxed text-[#F2EDE4]/65" data-testid="affiliate-disclosure">
            <span className="font-semibold text-[#F2EDE4]/85">Affiliate disclosure:</span> This website is owned and run by Rakesh Sharma, an independent ClickBank affiliate.
            If you buy through links on this page, Rakesh Sharma may earn a commission at no extra cost to you. ClickBank is the retailer of products on this site.
          </p>
          <p className="text-xs leading-relaxed text-[#F2EDE4]/65" data-testid="health-disclaimer">
            <span className="font-semibold text-[#F2EDE4]/85">Health disclaimer:</span> These statements have not been evaluated by the Food and Drug Administration.
            This product is not intended to diagnose, treat, cure or prevent any disease. Consult your physician before use. Individual results vary.
          </p>
        </div>
        <div className="flex flex-col gap-4 pb-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#F2EDE4]/55">© {year} gobbloo · Rakesh Sharma</p>
          <nav className="flex flex-wrap gap-x-5 gap-y-2 text-xs" data-testid="footer-legal-links">
            {[["Privacy", "privacy"], ["Terms", "terms"], ["Disclaimer", "disclaimer"], ["Affiliate Disclosure", "affiliate-disclosure"]].map(([l, s]) => (
              <Link key={s} to={`/${s}`} data-testid={`footer-legal-${s}`} className="text-[#F2EDE4]/70 hover:text-[#F2EDE4]">{l}</Link>
            ))}
          </nav>
        </div>
      </div>
      <p aria-hidden="true" className="pointer-events-none select-none text-center font-display text-[24vw] font-extrabold leading-[0.75] text-[#F2EDE4]/[0.05]">gobbloo</p>
    </footer>
  );
};
